import {CardPopupInformation, CardDataController, SelectPlayerAndResourceCardFormat} from '@colonist/game-card-types'
import {SectionBgAdaptiveView} from '../../ui_canvas_engine/SectionBgViewAdaptive'
import {UIGameManager} from '../UIGameManager'
import {PIXI} from '@colonist/pixi'
import {UIGamePopupSelectPlayers} from './UIGamePopupSelectPlayers'
import {UIGamePopupSelectCardToGiveToPlayer} from './UIGamePopupSelectCardToGiveToPlayer'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGamePopupCardConfirmation} from './UIGamePopupCardConfirmation'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {PlayerColor} from '@colonist/game-states'

export abstract class UIGamePopupSelectPlayerAndResourceCard extends SectionBgAdaptiveView implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private activeView: PIXI.Container | undefined
    private selectPlayerView: UIGamePopupSelectPlayers | undefined
    private selectCardView: UIGamePopupSelectCardToGiveToPlayer | undefined
    private cancelEntireStateView: UIGamePopupCardConfirmation | undefined
    protected readonly popupImageAndDescription: PIXI.Container
    protected readonly selectionFormat: SelectPlayerAndResourceCardFormat

    constructor(uiGameManager: UIGameManager, popupImageAndDescription: PIXI.Container, selectionFormat: SelectPlayerAndResourceCardFormat) {
        super()
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.popupImageAndDescription = popupImageAndDescription
        this.selectionFormat = selectionFormat

        this.activeView = undefined

        this.buildPopupSelectPlayer()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated: if(!this.isValidActionState()) this.destroyActiveView(); break
            default: break
        }
    }

    private setActiveView(newView: PIXI.Container) {
        this.destroyActiveView()
        this.uiGameManager.eventController.sendEvent(newView, UIGameEventEnums.PopupActive)
        this.activeView = newView
        this.uiGameManager.canvasController.app.stage.addChild(this.activeView)
    }

    private destroyActiveView() {
        if(this.selectCardView != undefined) this.selectCardView.hide()
        if(this.activeView == undefined) return
        this.activeView.destroy()
    }

    private buildPopupSelectPlayer() {
        this.selectPlayerView = new UIGamePopupSelectPlayers(this.uiGameManager, this.popupImageAndDescription, this.selectionFormat.selectPlayerFormat, this.selectionFormat.developmentCardUsed)

        this.selectPlayerView.removeConfirmationButtons()

        this.selectPlayerView.addCancelStateButton(() => this.cancelEntireState())

        const clickedPlayerView = (player: PlayerColor) => this.selectPlayerAction(player)
        this.selectPlayerView.addSelectPlayerCallback(clickedPlayerView)

        this.setActiveView(this.selectPlayerView)
    }

    private selectPlayerAction(player: PlayerColor) {
        this.uiGameManager.socketGameSend.selectPlayer(player)
        this.buildPopupSelectCard(player)
    }

    private buildPopupSelectCard(playerReceivingCard: PlayerColor) {
        this.selectCardView = this.createPopupSelectCardToGiveToPlayer(playerReceivingCard)
        this.setActiveView(this.selectCardView)
        this.selectCardView.showCardsToSelectFrom()
    }

    protected cancelSelectCard() {
        if(this.selectCardView == undefined) return
        this.uiGameManager.socketGameSend.cancelAction()
        this.buildPopupSelectPlayer()
    }

    private isValidActionState(): boolean {
        if(this.uiGameManager.gameController.currentState.actionState == this.selectionFormat.selectCardFormat.allowableActionState) return true
        return false
    }

    private cancelEntireState() {
        const cardData = CardDataController.getCardDataForCard(this.selectionFormat.developmentCardUsed)
        if(cardData == undefined) return

        const cancelPopupInformation: CardPopupInformation = {
            cardEnum: this.selectionFormat.developmentCardUsed,
            cardBody: {key: 'strings:game.prompts.endCommercialHarbor'},
        }

        this.cancelEntireStateView = this.createPopupCardConfirmation(cancelPopupInformation)

        const abortCancelingState = () => this.buildPopupSelectPlayer()
        this.cancelEntireStateView.setCancelAction(abortCancelingState)

        const confirmCancelingState = () => {
            this.uiGameManager.socketGameSend.cancelAction()
            this.destroyActiveView()
        }
        this.cancelEntireStateView.setCheckAction(confirmCancelingState)

        this.setActiveView(this.cancelEntireStateView)
    }

    protected abstract createPopupCardConfirmation(cancelPopupInformation: CardPopupInformation): UIGamePopupCardConfirmation
    protected abstract createPopupSelectCardToGiveToPlayer(playerReceivingCard: PlayerColor): UIGamePopupSelectCardToGiveToPlayer
}
